/* eslint-disable max-len */
import { ICONS_ID } from '@bitComponents/unifiedIcons/SvgIconLoader';
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: 'Hola {name}, completa tu pedido',
      [STRING_KEYS.summary.cart.manualOneTimeChargesTitle]: '',
      [STRING_KEYS.summary.cart.manualOneTimeChargesFinalPriceText]: 'Pago único',
      [STRING_KEYS.summary.cart.manualRecurringChargesFinalPriceText]: 'Cuota mensual',
      [STRING_KEYS.summary.cashOnDelivery.title]: 'Forma de pago saldo inicial tarjeta',
      [STRING_KEYS.summary.cashOnDelivery.text]: 'Contrarrembolso en efectivo.',
      [STRING_KEYS.summary.cashOnDelivery.secondaryText]: '',
      [STRING_KEYS.summary.prepaidActivation.title]: 'Activación tarjeta y recargas',
      [STRING_KEYS.summary.prepaidActivation.text]: 'Ten en cuenta que tendrás que activar la tarjeta y tener el saldo necesario cada 4 semanas para mantener la tarifa contratada.',
      [STRING_KEYS.summary.prepaidActivation.secondaryText]: ' Te enviaremos un mail indicándote como hacerlo.',
      [STRING_KEYS.summary.staticDirectDebit]: 'En la factura del número móvil asociado.',
      [STRING_KEYS.provisionalAgreement.title]: '',
      [STRING_KEYS.provisionalAgreement.pdfLinkText]: 'Descarga del resumen del contrato (PDF).',
      [STRING_KEYS.payment.step.insertDirectDebit]: '',
      [STRING_KEYS.se.message.payment.sameAccount]: '',
      [STRING_KEYS.mainAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
      [STRING_KEYS.mobileSecondaryAction[CQ_ACTION_CODES.MIGRATION].multiplePhoneNumbers]: 'Quiero pasar un número Movistar a esta tarifa',
      [STRING_KEYS.summary.manualSummaryAdvice.text]: 'Si ya tienes una MultiSIM y quieres solicitar el cambio a 0 €/mes ',
      [STRING_KEYS.summary.manualSummaryAdvice.linkText]: 'pulsa aquí',
      [STRING_KEYS.summary.manualSummaryAdvice.link]: 'https://app.movistar.es/form/cliente/multisim',
      [STRING_KEYS.summary.cart.recurringChargesFinalPriceTextBelow[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: '',
      [STRING_KEYS.selectParentProduct.subtitle]: 'Selecciona la línea móvil para la que quieres la MultiSIM',
      [STRING_KEYS.stepTitles.selectParentProduct]: 'Selecciona la línea móvil',
      [STRING_KEYS.stepTitles.numberOfSims]: 'Tarjetas adicionales',
      [STRING_KEYS.multiSimOptions.typeOfSims.text]: 'Indica el número de tarjetas adicionales que necesitas',
      [STRING_KEYS.summary.webAppShipping.title]: 'Entrega eSIMs',
      [STRING_KEYS.summary.webAppShipping.text]: 'La eSIM puede tardar hasta 30 minutos en estar disponible para la instalación en tu área privada/app de Movistar.',
      [STRING_KEYS.summary.webAppShipping.secondaryText]: '',
      [STRING_KEYS.summary.storeShipping.title]: 'Recogida en tienda de SIMs y eSIMs',
      [STRING_KEYS.summary.storeShipping.text]: 'Tendrás que acudir a una tienda Movistar a recoger las tarjetas solicitadas.',
      [STRING_KEYS.summary.storeShipping.secondaryText]: '',
      [STRING_KEYS.summary.storeShipping.adviceText]: 'Por seguridad no se realizan envíos a domicilio.',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
      [STRING_KEYS.summary.title]: '',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
